import store from "../store";
import { keys, without, union } from "lodash";
import rmd from "remove-markdown";

const stopWords = [
  "",
  "a",
  "about",
  "above",
  "after",
  "again",
  "against",
  "all",
  "am",
  "an",
  "and",
  "any",
  "are",
  "aren't",
  "as",
  "at",
  "be",
  "because",
  "been",
  "before",
  "being",
  "below",
  "between",
  "both",
  "but",
  "by",
  "can",
  "can't",
  "cannot",
  "could",
  "couldn't",
  "did",
  "didn't",
  "do",
  "does",
  "doesn't",
  "doing",
  "don't",
  "down",
  "during",
  "each",
  "few",
  "for",
  "from",
  "further",
  "had",
  "hadn't",
  "has",
  "hasn't",
  "have",
  "haven't",
  "having",
  "he",
  "he'd",
  "he'll",
  "he's",
  "her",
  "here",
  "here's",
  "hers",
  "herself",
  "him",
  "himself",
  "his",
  "how",
  "how's",
  "i",
  "i'd",
  "i'll",
  "i'm",
  "i've",
  "if",
  "in",
  "into",
  "is",
  "isn't",
  "it",
  "it's",
  "its",
  "itself",
  "let's",
  "me",
  "more",
  "most",
  "mustn't",
  "my",
  "myself",
  "no",
  "nor",
  "not",
  "of",
  "off",
  "on",
  "once",
  "only",
  "or",
  "other",
  "ought",
  "our",
  "ours",
  "ourselves",
  "out",
  "over",
  "own",
  "same",
  "shan't",
  "she",
  "she'd",
  "she'll",
  "she's",
  "should",
  "shouldn't",
  "so",
  "some",
  "such",
  "than",
  "that",
  "that's",
  "the",
  "their",
  "theirs",
  "them",
  "themselves",
  "then",
  "there",
  "there's",
  "these",
  "they",
  "they'd",
  "they'll",
  "they're",
  "they've",
  "this",
  "those",
  "through",
  "to",
  "too",
  "under",
  "until",
  "up",
  "very",
  "was",
  "wasn't",
  "we",
  "we'd",
  "we'll",
  "we're",
  "we've",
  "were",
  "weren't",
  "what",
  "what's",
  "when",
  "when's",
  "where",
  "where's",
  "which",
  "while",
  "who",
  "who's",
  "whom",
  "why",
  "why's",
  "with",
  "won't",
  "would",
  "wouldn't",
  "you",
  "you'd",
  "you'll",
  "you're",
  "you've",
  "your",
  "yours",
  "yourself",
  "yourselves",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];

function indexSearchItems(newsItems, resourceItems) {
  let searchIndex = {};

  for (const i in newsItems) {
    let titleWords = rmd(newsItems[i].headline)
      .toLowerCase()
      .split(/[\W/]+/);
    let bodyWords = rmd(newsItems[i].summary)
      .toLowerCase()
      .split(/[\W/]+/);
    let keywordWords = rmd(newsItems[i].keywords)
      .toLowerCase()
      .split(/[\W/]+/);

    let searchWords = without(
      union(titleWords, bodyWords, keywordWords).sort(),
      ...stopWords
    );

    // iterate through the search words; if they already exist, just add the uuid for the entry to them.
    for (const word of searchWords) {
      if (word in searchIndex) {
        searchIndex[word].push(newsItems[i].uuid);
      } else {
        searchIndex[word] = [newsItems[i].uuid];
      }
    }
  }

  for (const i in resourceItems) {
    let titleWords = rmd(resourceItems[i].title)
      .toLowerCase()
      .split(/[\W/]+/);
    let bodyWords = rmd(resourceItems[i].description)
      .toLowerCase()
      .split(/[\W/]+/);
    let keywordWords = rmd(resourceItems[i].keywords)
      .toLowerCase()
      .split(/[\W/]+/);

    let searchWords = without(
      union(titleWords, bodyWords, keywordWords).sort(),
      ...stopWords
    );

    // iterate through the search words; if they already exist, just add the uuid for the entry to them.
    for (const word of searchWords) {
      if (word in searchIndex) {
        searchIndex[word].push(resourceItems[i].uuid);
      } else {
        searchIndex[word] = [resourceItems[i].uuid];
      }
    }
  }

  store.set("searchItems", searchIndex);
}

function populateAsset(a, asset) {
  let language = "en-US";

  a.uuid = asset.sys.id;
  a.title = asset.fields.title[language];
  a.url = `https:${asset.fields.file[language].url}`;
  a.contentType = asset.fields.file[language].contentType;
  a.fileName = asset.fields.file[language].fileName;
  a.language = language;
}

function newAsset(asset) {
  let a = {};

  populateAsset(a, asset);

  return a;
}

function populateNewsItem(i, entry) {
  let language = "en-US";

  i.headline = entry.fields.headline[language];
  i.uuid = entry.sys.id;
  i.summary = entry.fields.summary[language];
  i.postingDate = entry.fields.postingDate[language];
  i.url = entry.fields.url[language];
  i.language = language;
  i.keywords = entry.fields.keywords ? entry.fields.keywords[language] : "";
  i.source = entry.fields.source
    ? entry.fields.source[language]
    : new URL(i.url).host;
  i.createdAt = entry.sys.createdAt;
  i.updatedAt = entry.sys.updatedAt;

  if ("image" in entry.fields) {
    let asset = store.get(`assetItems@${entry.fields.image[language].sys.id}`);

    i.image = asset ? asset.url : null;
  }
}

function newNewsItem(entry) {
  let i = {};

  populateNewsItem(i, entry);

  return i;
}

function populateCollectionItem(i, entry) {
  let language = "en-US";

  i.uuid = entry.sys.id;
  i.title = entry.fields.title[language];
  i.slug = entry.fields.slug[language];
  i.shortTitle = entry.fields.shortTitle
    ? entry.fields.shortTitle[language]
    : entry.fields.title[language];
  i.description = entry.fields.description
    ? entry.fields.description[language]
    : "";
  i.resources = entry.fields.resources[language]
    .map(res => res.sys.id)
    .join(",");
  i.type = "CollectionItem";
  i.isFAQ = entry.fields.questionAnswer
    ? entry.fields.questionAnswer[language]
    : false;

  if ("image" in entry.fields) {
    let asset = store.get(`assetItems@${entry.fields.image[language].sys.id}`);

    i.image = asset ? asset.url : null;
  }
}

function newCollectionItem(entry) {
  let i = {};

  populateCollectionItem(i, entry);

  return i;
}

function populateResourceItem(i, entry) {
  let language = "en-US";

  if (entry.sys.contentType.sys.id === "podcast") {
    // console.log("podcast", entry);
    i.uuid = entry.sys.id;
    i.title = entry.fields.title[language];
    i.author = entry.fields.author ? entry.fields.author[language] : "";
    i.summary = entry.fields.summary ? entry.fields.summary[language] : "";
    i.description = entry.fields.description[language];
    i.language = language;
    i.postingDate = entry.sys.createdAt;
    i.keywords = entry.fields.keywords ? entry.fields.keywords[language] : "";
    i.type = "AudioItem";
    i.createdAt = entry.sys.createdAt;
    i.updatedAt = entry.sys.updatedAt;

    if ("audioFile" in entry.fields) {
      let asset = store.get(
        `assetItems@${entry.fields.audioFile[language].sys.id}`
      );

      i.url = asset ? asset.url : null;
    }
  } else if (entry.sys.contentType.sys.id === "questionAnswer") {
    // console.log("questionAnswer", entry);
    i.uuid = entry.sys.id;
    i.title = entry.fields.question[language];
    i.description = entry.fields.answer[language];
    i.language = language;
    i.postingDate = entry.sys.createdAt;
    i.keywords = entry.fields.keywords ? entry.fields.keywords[language] : "";
    i.type = "QuestionAnswerItem";
    i.createdAt = entry.sys.createdAt;
    i.updatedAt = entry.sys.updatedAt;
  } else if (entry.sys.contentType.sys.id === "video") {
    // console.log("video", entry);
    i.uuid = entry.sys.id;
    i.title = entry.fields.title[language];
    i.author = entry.fields.author[language];
    i.summary = entry.fields.summary ? entry.fields.summary[language] : "";
    i.description = entry.fields.description
      ? entry.fields.description[language]
      : "";
    i.language = language;
    i.postingDate = entry.sys.createdAt;
    i.keywords = entry.fields.keywords ? entry.fields.keywords[language] : "";
    i.type = "VideoItem";
    i.createdAt = entry.sys.createdAt;
    i.updatedAt = entry.sys.updatedAt;

    if ("snapshot" in entry.fields) {
      let asset = store.get(
        `assetItems@${entry.fields.snapshot[language].sys.id}`
      );

      i.image = asset ? asset.url : null;
    }

    if ("videoFile" in entry.fields) {
      let asset = store.get(
        `assetItems@${entry.fields.videoFile[language].sys.id}`
      );

      i.url = asset ? asset.url : null;
    }
  } else if (entry.sys.contentType.sys.id === "formattedText") {
    // console.log("formattedText", entry);
    i.uuid = entry.sys.id;
    i.title = entry.fields.title[language];
    i.language = language;
    i.summary = entry.fields.summary ? entry.fields.summary[language] : "";
    i.description = entry.fields.text[language];
    i.keywords = entry.fields.keywords ? entry.fields.keywords[language] : "";
    i.type = "TextItem";
    i.postingDate = entry.sys.createdAt;
    i.createdAt = entry.sys.createdAt;
    i.updatedAt = entry.sys.updatedAt;
  }
}

function newResourceItem(entry) {
  let i = {};

  populateResourceItem(i, entry);

  return i;
}

function storeAssets(assets) {
  // console.log("storeAssets", assets.length);
  if (assets.length > 0) {
    let storedAssets = store.get("assetItems");

    for (const asset of assets) {
      let a;
      if (keys(storedAssets).length > 0) {
        // asset might already exist - need to find it if it exists
        a = storedAssets[asset.sys.id];

        if (a) {
          // overwrite existing asset information
          populateAsset(a, asset);
        } else {
          // doesn't exist - create a new asset
          a = newAsset(asset);
          storedAssets[a.uuid] = a;
        }
      } else {
        // can just create a new asset
        a = newAsset(asset);
        storedAssets[a.uuid] = a;
      }
    }

    store.set("assetItems", storedAssets);
  }
}

function storeEntries(entries) {
  // console.log("storeEntries", entries.length);

  if (entries.length > 0) {
    let storedNewsItems = store.get("newsItems");
    let storedResourceItems = store.get("resourceItems");
    let storedCollectionItems = store.get("collectionItems");

    // console.log("storedAssets", storedAssets);

    for (const entry of entries) {
      let e;
      if (
        entry.sys.contentType &&
        entry.sys.contentType.sys.id === "newsItem"
      ) {
        // newsItem
        if (keys(storedNewsItems).length > 0) {
          // entry might already exist - need to find it if it exists
          e = storedNewsItems[entry.sys.id];

          if (e) {
            // overwrite existing entry information
            populateNewsItem(e, entry);
          } else {
            // doesn't exist - create a new entry
            e = newNewsItem(entry);
            storedNewsItems[e.uuid] = e;
          }
        } else {
          // can just create a new entry
          e = newNewsItem(entry);
          storedNewsItems[e.uuid] = e;
        }
      } else if (
        entry.sys.contentType &&
        entry.sys.contentType.sys.id === "collection"
      ) {
        // collectionItem
        if (keys(storedCollectionItems).length > 0) {
          // entry might already exist - need to find it if it exists
          e = storedCollectionItems[entry.sys.id];

          if (e) {
            // overwrite existing entry information
            populateCollectionItem(e, entry);
          } else {
            // doesn't exist - create a new entry
            e = newCollectionItem(entry);
            storedCollectionItems[e.uuid] = e;
          }
        } else {
          // can just create a new entry
          e = newCollectionItem(entry);
          storedCollectionItems[e.uuid] = e;
        }
      } else if (
        entry.sys.contentType &&
        (entry.sys.contentType.sys.id === "podcast" ||
          entry.sys.contentType.sys.id === "questionAnswer" ||
          entry.sys.contentType.sys.id === "video" ||
          entry.sys.contentType.sys.id === "formattedText")
      ) {
        // resourceItems
        if (keys(storedResourceItems).length > 0) {
          // entry might already exist - need to find it if it exists
          e = storedResourceItems[entry.sys.id];

          if (e) {
            // overwrite existing entry information
            populateResourceItem(e, entry);
          } else {
            // doesn't exist - create a new entry
            e = newResourceItem(entry);
            storedResourceItems[e.uuid] = e;
          }
        } else {
          // can just create a new entry
          e = newResourceItem(entry);
          storedResourceItems[e.uuid] = e;
        }
      } else if (
        entry.sys.contentType &&
        entry.sys.contentType.sys.id === "introPage"
      ) {
        // console.log("Intro page", entry);

        // get the existing intro item;
        let storedIntroItem = store.get("introItem");

        if (storedIntroItem === null) {
          let language = "en-US";
          storedIntroItem = {};
          storedIntroItem.title = entry.fields.title[language];
          storedIntroItem.introText = entry.fields.introText[language];
          storedIntroItem.createdAt = entry.sys.createdAt;
          storedIntroItem.updatedAt = entry.sys.updatedAt;

          store.set("introItem", storedIntroItem);
        }
      } else if (
        entry.sys.contentType &&
        entry.sys.contentType.sys.id === "infoPage"
      ) {
        // console.log("Info page", entry);

        // get the existing info item;
        let storedInfoItem = store.get("infoItem");

        if (storedInfoItem === null) {
          let language = "en-US";
          storedInfoItem = {};
          storedInfoItem.title = entry.fields.title[language];
          storedInfoItem.infoText = entry.fields.infoText[language];
          storedInfoItem.acknowledgements =
            entry.fields.acknowledgements[language];
          storedInfoItem.createdAt = entry.sys.createdAt;
          storedInfoItem.updatedAt = entry.sys.updatedAt;

          store.set("infoItem", storedInfoItem);
        }
      } else {
        console.log("Unknown entry type", entry);
      }
    }

    store.set("newsItems", storedNewsItems);
    store.set("resourceItems", storedResourceItems);
    store.set("collectionItems", storedCollectionItems);

    indexSearchItems(storedNewsItems, storedResourceItems);
  }
}

function deleteAssets(assets) {
  // console.log("deleteAssets", assets.length);

  if (assets.length > 0) {
    // entries are deleted prior to assets, so we should be able to assume
    // that no entries reference the assets being deleted.
    let storedAssets = store.get("assetItems");

    for (const asset of assets) {
      delete storedAssets[asset.sys.id];
    }

    store.set("assetItems", storedAssets);
  }
}

function deleteEntries(entries) {
  // console.log("deleteEntries", entries.length);

  if (entries.length > 0) {
    // entries can be in the newsItems, resourceItems, or collectionItems collections
    // can just delete from all three
    let storedNewsItems = store.get("newsItems");
    let storedResourceItems = store.get("resourceItems");
    let storedCollectionItems = store.get("collectionItems");

    for (const entry of entries) {
      delete storedNewsItems[entry.sys.id];
      delete storedResourceItems[entry.sys.id];
      delete storedCollectionItems[entry.sys.id];
    }

    store.set("newsItems", storedNewsItems);
    store.set("resourceItems", storedResourceItems);
    store.set("collectionItems", storedCollectionItems);
  }
}

export { storeAssets, storeEntries, deleteAssets, deleteEntries, stopWords };
